import request from '@/utils/request'

export function zzdqList(data){
  return request({
    method: 'post',
    url: '/yzdservice/api/notification/zzdq/list',
    data: data
  })
}
export function zjwsyGmzlist(data){
  return request({
    method: 'post',
    url: '/yzdservice/api/notification/zjwsy/gmzlist',
    data: data
  })
}

export function removeWsyById(id){
  return request({
    method: 'delete',
    url: '/yzdservice/api/notification/zjwsy/removeById/'+id
  })
}

export function zjwsyYszlist(data){
  return request({
    method: 'post',
    url: '/yzdservice/api/notification/zjwsy/yszlist',
    data: data
  })
}

export function zjhxList(data){
  return request({
    method: 'post',
    url: '/yzdservice/api/notification/zjhx/list',
    data: data
  })
}
export function removeHxById(id){
  return request({
    method: 'delete',
    url: '/yzdservice/api/notification/zjhx/removeById/'+id
  })
}


export function zrsdqtxList(data){
  return request({
    method: 'post',
    url: '/yzdservice/api/notification/zrsdqtx/list',
    data: data
  })
}
